var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"title":"Willkommen im Buchungsportal."}},[_c('b-card-text'),_c('b-button',{attrs:{"variant":"info","block":"","to":{ name: 'TA-Voucher' }}},[_vm._v(" Jetzt eine Fahrt buchen ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }